import * as React from 'react';
import Button from '../../../../components/Button';
import { HomeTabListHeaderStyle } from './style';

interface HomeTabListHeaderProps {
  title: string;
  onClickCreateTab: () => void;
}

const HomeTabListHeader = (props: HomeTabListHeaderProps): JSX.Element => {
  const { title, onClickCreateTab } = props;

  return (
    <HomeTabListHeaderStyle>
      <h2>{title}</h2>
      <Button text={'+ 탭 추가'} color="black" isRadius={true} onClick={onClickCreateTab} />
    </HomeTabListHeaderStyle>
  );
};

export default HomeTabListHeader;
